var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0zM10 18a2 2 0 1 1 4 0 2 2 0 0 1-4 0zM12 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4z",
    fill: "#383634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewActionIcon);
export default __webpack_public_path__ + "static/media/overview_action_icon.79621e720c2546f5c7090259eb464f18.svg";
export { ForwardRef as ReactComponent };